import script from "./ButtonFixedSecondary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonFixedSecondary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonFixedSecondary.vue?vue&type=style&index=0&id=b0c1bd66&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0c1bd66"]])

export default __exports__